import { IExternalLinkModel } from '@api/models';
import DeleteConfirmationDrawer from '@library/drawer/components/DeleteConfirmationDrawer';
import useDeleteExternalLinkForm from 'modules/documents/hooks/useDeleteExternalLinkForm';
import { toast } from 'react-toastify';

interface DeleteExternalLinkDrawerProps {
    clientId: string;
    show: boolean;
    onClose: () => void;
    externalLink: IExternalLinkModel;
    onDelete: (externalLinkId: string) => void;
}

const DeleteExternalLinkDrawer = (props: DeleteExternalLinkDrawerProps) => {
    const { clientId, show, onClose, externalLink, onDelete } = props;

    const deleteExternalLinkForm = useDeleteExternalLinkForm({ clientId, externalLink });

    const handleDelete = async () => {
        try {
            await deleteExternalLinkForm.submit();

            onDelete(externalLink._id);

            toast.success('External link deleted successfully.');

            onClose();
        } catch (err: any) {
            toast.error(err.data.message || 'Some error occurred, please try again');
        }
    };

    return (
        <DeleteConfirmationDrawer
            open={show}
            onClose={onClose}
            title="Delete External Link"
            message={
                <>
                    The following link <span className="text-grayscale-900">“{externalLink?.name}”</span> will be
                    deleted.
                </>
            }
            onConfirm={handleDelete}
            isConfirming={deleteExternalLinkForm.isLoading}
        />
    );
};

export default DeleteExternalLinkDrawer;
